import * as React from 'react';
import { useSelector } from 'react-redux';

import { AgentAsideCard, Honest, DocumentsChecked } from '../../components/HeroResultSection';
import { MainCommentContainer } from '../Comments/MainCommentContainer';
import { getAuthor } from '../../selectors/author';
import { getName } from './utils';
import { AgentContactsContainer } from '../AgentContactsContainer';
import { mapBackToFrontLeverOrder } from './utils/mapBackToFrontLeverOrder';

export const AgentAsideCardContainer: React.FC = () => {
  const { firstName, lastName, cianUserId, age, avatarUrl, moderationInfo } = useSelector(getAuthor);
  const name = getName({ firstName, lastName, authorId: cianUserId });
  const { levelName, levelOrderName, hasVerifiedDocuments } = moderationInfo || {};

  const honest =
    levelOrderName && levelName ? (
      <Honest honestLevel={mapBackToFrontLeverOrder[levelOrderName]} title={levelName} />
    ) : null;
  const documentsChecked = hasVerifiedDocuments ? <DocumentsChecked /> : null;

  return (
    <AgentAsideCard
      name={name}
      honest={honest}
      documentsChecked={documentsChecked}
      experience={age}
      avatarUrl={avatarUrl || ''}
      footer={
        <>
          <MainCommentContainer />
          <AgentContactsContainer />
        </>
      }
    />
  );
};

AgentAsideCardContainer.displayName = 'AgentAsideCardContainer';
